<template>
  <div class="home-page">
    <image-carousel :slides="carouselSlides" :loading="loading.carousel" />
    
    <div class="content-container">
      
      <content-section 
        title="歌手" 
        :items="singerItems"
        :max-items="9"
        :loading="loading.singer"
        @more-click="navigateToMore('singer')"
        @play-video="playVideo"
      />
      
    </div>
  </div>
</template>

<script>
import ImageCarousel from '../components/Carousel.vue';
import ContentSection from '../components/ContentSection.vue';
import { getCategoryList } from '../api';
import { IMAGE_BASE_URL } from '../utils/constants';
// 导入图片
import banner1 from '../assets/banner1.png';
import banner2 from '../assets/banner2.png';
import banner3 from '../assets/banner3.png';

export default {
  name: 'HomePage',
  components: {
    ImageCarousel,
    ContentSection
  },
  data() {
    return {
      IMAGE_BASE_URL,
      carouselSlides: [
        {
          id: 1,
          title: '新疆是个好地方',
          image: banner1
        },
        {
          id: 2,
          title: '美丽的天山',
          image: banner2
        },
        {
          id: 3,
          title: '丝绸之路的明珠',
          image: banner3
        }
      ],
      mvItems: [],
      singerItems: [],
      allItems: [],
      loading: {
        carousel: true,
        mv: true,
        singer: true,
        all: true
      }
    }
  },
  created() {
    // 模拟轮播图加载
    setTimeout(() => {
      this.loading.carousel = false;
    }, 800);
    
    // 加载各分类数据
    this.loadSingerData();
  },
  methods: {
    async loadSingerData() {
      this.loading.singer = true;
      try {
        const response = await getCategoryList(0, 53);
        if (response && response.data) {
          // 只取前9个
          this.singerItems = response.data.data.slice(0, 9);
        }
      } catch (error) {
        console.error('获取歌手数据失败:', error);
      } finally {
        // 添加短暂延迟，确保加载动画效果
        setTimeout(() => {
          this.loading.singer = false;
        }, 700);
      }
    },
    navigateToMore(type) {
      // 触发父组件的菜单切换
      this.$emit('navigate', type);
    },
    playVideo(id) {
      // 对于歌手内容，使用音频播放器；其他内容使用视频播放器
      this.$emit('play-audio', id);
    }
  }
}
</script>

<style scoped>
.home-page {
  /* padding: 20px; */
  padding-bottom: 40px;
}

.content-container {
  padding-top: 20px;
}
</style> 